import type { CustomerFilter } from '~/types/customer-filter'

export const EMPTY_FILTER: CustomerFilter = {}

export function isEmptyFilter(f: CustomerFilter | null | undefined): boolean {
  if (!f) return true
  if (f.subscription_status?.length) return false
  if (f.partners?.length) return false
  if (f.policy_holders?.length) return false
  if (f.tags?.length) return false
  if (f.gender?.length) return false
  if (f.country?.values?.length) return false
  if (f.age && (f.age.min != null || f.age.max != null)) return false
  if (f.min_switched_calls != null) return false
  return true
}

export function buildMatchArgs(input: {
  filter: CustomerFilter
  includes?: string[]
  excludes?: string[]
  search?: string
}): { p_filters: CustomerFilter; p_includes: string[]; p_excludes: string[]; p_search: string | null } {
  return {
    p_filters: input.filter ?? {},
    p_includes: input.includes ?? [],
    p_excludes: input.excludes ?? [],
    p_search: input.search?.trim() || null,
  }
}
